/**
 * Mock functions for OS Actions.
 * These functions are used to simulate native os actions that are not available in non-prod envs.
 * They are primarily used for testing purposes.
 */

import { useCallback } from 'react';

import { useToast } from 'hooks/use-toast';

export const useOsActionMocks = () => {
  const toast = useToast();

  const mockPromptReview = useCallback(() => {
    toast.show({
      duration: 5000,
      text: 'Mock prompt review action triggered. This is a placeholder for the actual review prompt',
      variant: 'informative',
      id: 'mock-prompt-review',
      placement: 'top',
    });
  }, [toast]);

  return {
    mockPromptReview,
  };
};
